import { render } from "./PeopleIcon.vue?vue&type=template&id=68ad02ae"
import script from "./PeopleIcon.vue?vue&type=script&lang=js"
export * from "./PeopleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__